import(/* webpackMode: "eager" */ "/home/u551131594/domains/bizzbox.social/hbuilds/source/repository/src/app/friends/page.tsx");
